import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { LocaleContext } from 'styles/locale-provider'
import Button from 'components/ui-elements/button'
import { Wrap, Container, Item, Content, ImgWrap, Title } from './index.styled'

const BottomNavSection = ({ className }) => {
  const { localeText, getI18Url, lang } = React.useContext(LocaleContext)
  const { pathname } = useLocation()
  const mainUrl =
    pathname.split('/')[1] === lang
      ? pathname.split('/')[2]
      : pathname.split('/')[1]

  const {
    destination,
    design,
    nature,
    revitalization,
    dining
  } = useStaticQuery(graphql`
    query BottomNavQuery {
      destination: file(relativePath: { eq: "bottom-nav/destination.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      design: file(relativePath: { eq: "bottom-nav/design.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      nature: file(relativePath: { eq: "bottom-nav/nature.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      revitalization: file(
        relativePath: { eq: "bottom-nav/revitalization.png" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      dining: file(relativePath: { eq: "bottom-nav/dining.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const items = [
    { title: 'Destination', url: '/', alt: '', file: destination },
    { title: 'Design', url: '/design', alt: '', file: design },
    { title: 'Nature', url: '/nature', alt: '', file: nature },
    {
      title: 'Revitalization',
      url: '/revitalization',
      alt: '',
      file: revitalization
    },
    { title: 'Dining', url: '/dining', alt: '', file: dining }
  ]
  const links = items.filter(
    (item) =>
      item.url !==
      (['destination', 'the-riviera-maya', 'press'].includes(mainUrl)
        ? '/'
        : `/${mainUrl}`)
  )

  return (
    <Wrap className={['black', className].join(' ')}>
      <Container>
        {links.map((item, i) => (
          <Item key={`botton-nav-item-${i}`} to={getI18Url(item.url)}>
            <ImgWrap>
              <GatsbyImage image={getImage(item?.file)} alt={item?.alt || ''} />
            </ImgWrap>
            <Content>
              <Title className='h2'>{item.title}</Title>
              <Button className='light'>{localeText['learn.button']}</Button>
            </Content>
          </Item>
        ))}
      </Container>
    </Wrap>
  )
}
export default BottomNavSection
